(function () {
  // Run before mon-faq-produit.js so its existing scroll-following rail can
  // attach to the native ordered list. No text or emphasis is reconstructed.
  function decorate(scope) {
    scope.querySelectorAll('.mon-fiche-rich--routine .metafield-rich_text_field > ol').forEach(function (list) {
      list.classList.add('mon-pfaq__etapes');
    });
    scope.querySelectorAll('.mon-fiche-rich--timeline .metafield-rich_text_field > ol').forEach(function (list) {
      list.classList.add('mon-pfaq__timeline');
      list.setAttribute('data-mon-pfaq-timeline', '');
      Array.from(list.children).forEach(function (item) { item.classList.add('mon-pfaq__step'); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { decorate(document); }, { once:true });
  } else {
    decorate(document);
  }
  document.addEventListener('shopify:section:load', function (event) { decorate(event.target); });
})();
